<template>
  <section class="provider_show_section">
    <h5 v-if="title" class="provider_show_section__title">{{ title }}</h5>
    <slot />
  </section>
</template>

<script>
export default {
  name: "ProviderShowSection",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
